// extracted by mini-css-extract-plugin
export default {"list":"FeedbackOptions_list__9fXmB","button":"FeedbackOptions_button__eOoGc","fadeOut":"FeedbackOptions_fadeOut__jyP+Q"};